<div [style.height.px]="filterHeight" class="bg-white px-2 mb-4 transition-all duration-200 overflow-hidden">
  <div class="flex justify-between border-b border-gray-200 py-2">
    <div>
      <span class="text-base font-medium text-amazone-orange">Filters</span>
      <p class="text-xs text-gray-600">Search results will be immediately updated as you select or deselect filters.</p>
    </div>
    <button
      class="bg-white rounded-full hover:cursor-pointer hover:text-amazone-orange hover:scale-110 transition-all duration-300"
      (click)="closeFilters()"
      appAgentAction
      agent="dtc-filter-close"
      businessObject="dtc"
      action="close"
    >
      <app-close-icon></app-close-icon>
    </button>
  </div>
  <div class="flex flex-wrap gap-x-4 gap-y-2 items-start mt-4 overflow-y-auto max-h-[340px] px-1 pb-4">
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Search In</span>
      <div class="grid gap-3 mt-2">
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInValue"
            (change)="onScopeChanged()"
          />
          <span>DTC</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInGroup"
            (change)="onScopeChanged()"
          />
          <span>Group</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInPriority"
            (change)="onScopeChanged()"
          />
          <span>Priority</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInMachineFields"
            (change)="onScopeChanged()"
          />
          <span>Machine Fields</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInDocumentationFields"
            (change)="onScopeChanged()"
          />
          <span>Documentation Fields</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInOtherFields"
            (change)="onScopeChanged()"
          />
          <span>Other Fields</span>
        </label>
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col">
      <span class="text-xs font-semibold text-gray-600 mb-2">Empty Fields</span>

      <div class="grid gap-x-1 gap-y-0.5 grid-cols-[max-content_1fr] items-center">
        <span class="text-xs text-gray-600">Details on Terminal</span>
        <app-three-state-toggle [(ngModel)]="searchQuery.detailsOnTerminalNotEmpty" (stateChange)="onScopeChanged()" />

        <span class="text-xs text-gray-600">Impl. Hint</span>
        <app-three-state-toggle [(ngModel)]="searchQuery.implementationHintNotEmpty" (stateChange)="onScopeChanged()" />

        <span class="text-xs font-light text-amazone-orange">Cause</span>
        <div></div>

        <span class="text-xs text-gray-600">Intern</span>
        <app-three-state-toggle [(ngModel)]="searchQuery.causeInternNotEmpty" (stateChange)="onScopeChanged()" />

        <span class="text-xs text-gray-600">Dealer</span>
        <app-three-state-toggle [(ngModel)]="searchQuery.causeDealerNotEmpty" (stateChange)="onScopeChanged()" />

        <span class="text-xs text-gray-600">Farmer</span>
        <app-three-state-toggle [(ngModel)]="searchQuery.causeFarmerNotEmpty" (stateChange)="onScopeChanged()" />

        <span class="text-xs font-light text-amazone-orange">Remedy</span>
        <div></div>

        <span class="text-xs text-gray-600">Intern</span>
        <app-three-state-toggle [(ngModel)]="searchQuery.remedyInternNotEmpty" (stateChange)="onScopeChanged()" />

        <span class="text-xs text-gray-600">Dealer</span>
        <app-three-state-toggle [(ngModel)]="searchQuery.remedyDealerNotEmpty" (stateChange)="onScopeChanged()" />

        <span class="text-xs text-gray-600">Farmer</span>
        <app-three-state-toggle [(ngModel)]="searchQuery.remedyFarmerNotEmpty" (stateChange)="onScopeChanged()" />
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Translationstate Terminal</span>
      <div class="grid gap-3 mt-2">
        @for (translationState of translationStatesTerminal; track $index) {
          <label class="inline-flex items-center gap-1 text-xs text-gray-700">
            <input
              type="checkbox"
              [checked]="translationState[1]"
              (change)="toggleTranslationStateTerminal(translationState[0])"
              class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            />
            <span>{{ pascalCaseToWords(translationState[0]) }}</span>
          </label>
        }
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Translationstate Documentation</span>
      <div class="grid gap-3 mt-2">
        @for (translationState of translationStatesDocumentation; track $index) {
          <label class="inline-flex items-center gap-1 text-xs text-gray-700">
            <input
              type="checkbox"
              [checked]="translationState[1]"
              (change)="toggleTranslationStateDocumentation(translationState[0])"
              class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            />
            <span>{{ pascalCaseToWords(translationState[0]) }}</span>
          </label>
        }
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col">
      @if (!recyclingModeEnabled) {
        <span class="text-xs font-semibold text-gray-600 mb-2">Error Message</span>

        <div class="grid gap-x-1 gap-y-0.5 grid-cols-[max-content_1fr] items-center mb-5">
          <span class="text-xs text-gray-600">Assigned</span>
          <app-three-state-toggle
            [(ngModel)]="searchQuery.hasErrorMessage"
            (stateChange)="onScopeChanged()"
            textTrue="Yes"
            textFalse="No"
          />
        </div>
      }
      <span class="text-xs font-semibold text-gray-600">Reviews</span>

      <div class="grid gap-x-1 gap-y-0.5 grid-cols-[max-content_1fr] items-center">
        <span class="text-xs text-gray-600">Reviewed by AS</span>
        <app-three-state-toggle
          [(ngModel)]="searchQuery.isReviewedByAfterSales"
          (stateChange)="onScopeChanged()"
          textTrue="Yes"
          textFalse="No"
        />

        <span class="text-xs text-gray-600">In review by AS</span>
        <app-three-state-toggle
          [(ngModel)]="searchQuery.hasActiveAfterSalesReview"
          (stateChange)="onScopeChanged()"
          textTrue="Yes"
          textFalse="No"
        />

        <span class="text-xs text-gray-600">Reviewed by TO</span>
        <app-three-state-toggle
          [(ngModel)]="searchQuery.isReviewedByTechnicalOrganisation"
          (stateChange)="onScopeChanged()"
          textTrue="Yes"
          textFalse="No"
        />

        <span class="text-xs text-gray-600">In review by TO</span>
        <app-three-state-toggle
          [(ngModel)]="searchQuery.hasActiveTechnicalOrganisationReview"
          (stateChange)="onScopeChanged()"
          textTrue="Yes"
          textFalse="No"
        />

        <span class="text-xs text-gray-600">On-terminal reviewed by TR</span>
        <app-three-state-toggle
          [(ngModel)]="searchQuery.mainLanguageTerminalFieldsReviewed"
          (stateChange)="onScopeChanged()"
          textTrue="Yes"
          textFalse="No"
        />

        <span class="text-xs text-gray-600">Doc. reviewed by TR</span>
        <app-three-state-toggle
          [(ngModel)]="searchQuery.mainLanguageDocumentationFieldsReviewed"
          (stateChange)="onScopeChanged()"
          textTrue="Yes"
          textFalse="No"
        />
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Other</span>
      <div class="grid gap-3 mt-2">
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.mainLanguageTerminalFieldsExportedForReview"
            (change)="onScopeChanged()"
          />
          <span>Main lang. on-terminal fields exported for review</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.mainLanguageDocumentationFieldsExportedForReview"
            (change)="onScopeChanged()"
          />
          <span>Main lang. documentation fields exported for review</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [checked]="searchQuery.changesBy != undefined"
            (change)="changesByMe()"
          />
          <span>Changes by me</span>
        </label>
      </div>
    </div>

    <button
      type="button"
      class="ml-auto text-white bg-amazone-gray hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-3 py-1.5 cursor-pointer self-end"
      (click)="resetFilters()"
      appAgentAction
      agent="dtc-filter-reset"
      businessObject="dtc"
      action="reset"
    >
      Reset
    </button>
  </div>
</div>
